/**
 * Generated runtime TestId mirror for frontend/src/pages/NotificationTemplateDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const NotificationTemplateDetailTestIds = {
  badgeCustomised: "badge-customised",
  badgeDefault: "badge-default",
  btnCancel: "btn-cancel",
  btnRestoreDefault: "btn-restore-default",
  btnSave: "btn-save",
  btnTestSend: "btn-test-send",
  cardNotificationTemplateMetadata: "card-notification-template-metadata",
  cardTitleEditor: "card-title-editor",
  dialogRestoreDefault: "dialog-restore-default",
  inputSubject: "input-subject",
  inputTitle: "input-title",
  notificationTemplateDetailPage: "notification-template-detail-page",
  textareaBody: "textarea-body",
  textareaMessage: "textarea-message",
  variablePicker: "variable-picker",
  variable: (v_name: string) => `variable-${v_name}`,
  variablePrefix: () => "variable-" as TestIdPrefix
} as const;
